import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import webLogin from '@utils/weblogin';
// QueryInfo 缓存 数据
var cachVideoInfoData = null;
export default {
  data: function data() {
    return {
      // 直播间拦截
      modelVisible: false,
      allowed: false,
      // 是否黑白名单
      popupText: ''
    };
  },
  inject: ['getNuxtContext'],
  methods: {
    fetchLiveQueryInfo: function fetchLiveQueryInfo(channel, locale, authentication) {
      var _arguments = arguments,
        _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var isMust, _ref, videoInfoData, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              isMust = _arguments.length > 3 && _arguments[3] !== undefined ? _arguments[3] : false;
              _ref = typeof _this.getNuxtContext === 'function' ? _this.getNuxtContext() : {}, videoInfoData = _ref.videoInfoData; // 有缓存 && 有权限进入 返回缓存结果
              if (!(!isMust && videoInfoData && !webLogin.checkLogin())) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return", videoInfoData);
            case 4:
              if (!(!isMust && cachVideoInfoData)) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return", cachVideoInfoData);
            case 6:
              _context.next = 8;
              return _this.VideoAPIService.joinChannel(channel, locale, authentication || {});
            case 8:
              res = _context.sent;
              cachVideoInfoData = res;
              return _context.abrupt("return", res);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 查询 直播间信息
    getLiveRoomInfo: function getLiveRoomInfo() {
      var _arguments2 = arguments,
        _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var isMust, callback, _yield$_this2$fetchLi, _yield$_this2$fetchLi2, videoInfo;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              isMust = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : false;
              callback = _arguments2.length > 1 ? _arguments2[1] : undefined;
              _context2.next = 4;
              return _this2.fetchLiveQueryInfo(_this2.channel, _this2.locale, _this2.authentication || {}, isMust);
            case 4:
              _yield$_this2$fetchLi = _context2.sent;
              _yield$_this2$fetchLi2 = _yield$_this2$fetchLi.video_info;
              videoInfo = _yield$_this2$fetchLi2 === void 0 ? {} : _yield$_this2$fetchLi2;
              // 是否 有权限进入 直播间
              _this2.getAllowedForRoom(videoInfo);
              callback && callback();
              return _context2.abrupt("return", videoInfo);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getAllowedForRoom: function getAllowedForRoom(_ref2) {
      var isblack = _ref2.isblack,
        isRemoveRoom = _ref2.isRemoveRoom;
      // live/queryinfo    data->video_info->isblack=1是黑名单   isRemoveRoom=1  被主播移除直播间
      // 移入 黑名单
      if (isblack === '1') {
        this.popupText = this.$t('liveroom.intercept-model-blacklist-text');
        this.modelVisible = true;
        this.allowed = false;
        return false;
      }
      // 提出房间
      if (isRemoveRoom === '1') {
        this.popupText = this.$t('liveroom.intercept-model-goOut-text');
        this.modelVisible = true;
        this.allowed = false;
        return false;
      }
      this.allowed = true;
      return false;
    },
    // 消息回掉
    messageCallBack: function messageCallBack(_ref3) {
      var type = _ref3.type;
      // 直播间踢人
      if (type === 'app:forbidspeakmsgcontent') {
        this.getLiveRoomInfo();
      }
      // 直播间切换付费模式 切换
      if (type === 'app:liveswitchpaymentmode') {
        this.getAllowedForRoom({
          isRemoveRoom: '1'
        });
      }
    }
  },
  mounted: function mounted() {}
};